import { useState } from 'react';
import { pdfjs } from 'react-pdf';


pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function PDFViewer({ pdfUrl }) {
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'dokuman.pdf';
        link.click();
    };

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ marginBottom: '10px' }}>
                <button onClick={handleDownload}>PDF İndir</button>
            </div>
        </div>
    );
}

export default PDFViewer;